import React from 'react';

const IconCursor: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 50 50'
    width={props.width || 24}
    height={props.height || 24}
    focusable='false'
    role='presentation'
    data-icon-credit='Cursor AI icon by Icons8 - https://icons8.com/icons/set/cursor-ai'
    fill='none'
    {...props}
    className={`icon icon-cursor${props.className ? ' ' + props.className : ''}`}
  >
    <path d='M 24.984375 2.984375 A 1.0001 1.0001 0 0 0 24.363281 3.2148438 L 6.4804688 14.146484 A 1.0001 1.0001 0 0 0 6.0019531 14.998047 L 6 35 A 1.0001 1.0001 0 0 0 6.4785156 35.853516 L 24.478516 46.853516 A 1.0001 1.0001 0 0 0 25.521484 46.853516 L 43.519531 35.851562 A 1.0001 1.0001 0 0 0 43.998047 34.998047 L 43.998047 15 A 1.0001 1.0001 0 0 0 43.519531 14.146484 L 25.644531 3.21875 A 1.0001 1.0001 0 0 0 24.984375 2.984375 z M 24 5.78125 L 24.001953 14.994141 A 1.0001 1.0001 0 0 0 24.001953 15.003906 L 8.8945312 15.015625 L 24 5.78125 z M 26 5.78125 L 41.068359 14.992188 L 26.001953 15.003906 A 1.0001 1.0001 0 0 0 26.001953 14.994141 L 26 5.78125 z M 8.0019531 16.888672 A 1.0001 1.0001 0 0 0 8.0117188 16.894531 L 22.947266 25.009766 L 8 33.314453 L 8.0019531 16.888672 z M 41.998047 17.421875 L 41.998047 32.873047 L 35.121094 29.197266 L 41.998047 17.421875 z M 24.025391 26.701172 L 24.025391 44.232422 L 8.9980469 35.048828 L 24.025391 26.701172 z M 34.111328 30.925781 L 41.384766 34.8125 L 26.541016 43.884766 L 34.111328 30.925781 z' />
  </svg>
);

export default IconCursor;
